import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { EncuestaService } from '../services/encuesta.service';
import { Poll } from '../models/encuesta';

@Component({
    selector: 'app-encuesta',
    templateUrl: './encuesta.component.html',
    styleUrls: ['./encuesta.component.css'],
    providers: [EncuestaService]
})

export class EncuestaComponent implements OnInit {
    public loading: boolean;
    public encuesta: Poll;
    constructor(
        private _router: Router,
        private _route: ActivatedRoute,
        private _encuestaService: EncuestaService
    ) {
        this.encuesta = new Poll();
     }
    ngOnInit() { }
    createEncuesta() {
        this.loading = true;
        this.encuesta.date = new Date();
        this._encuestaService.create(this.encuesta).subscribe(
            response => {
                if (response.message === 'OK') {
                    this.loading = false;
                    alert('Gracias');
                    this.encuesta = new Poll();
                } else {
                    console.log(response);
                }
            },
            error => {
                console.log(<any>error);
            }
        );
    }
}